import React from "react";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import {Controller, useForm} from "react-hook-form";

import {classNames} from "../../../utils/Utils";
import InputText from "../../../components/common/form/input-text";
import InputFormattedNumber from "../../../components/common/form/input-formatted-number";
import InputSubmit from "../../../components/common/form/input-submit";
import {Warning} from "../../../components/common/alert/banner";
import {HEADER_COMPACT_CLASS} from "./document-header-utils";

const VatModalForm = ({onSubmitData, isLoading, exception}) => {
    const {t} = useTranslation();
    const {
        register,
        control,
        handleSubmit,
        formState: {errors},
    } = useForm({
        defaultValues: {
            name: "",
            code: "",
            description: "",
            value: null,
        },
    });

    return (
        <form
            onSubmit={handleSubmit(onSubmitData)}
            className={classNames("space-y-3", HEADER_COMPACT_CLASS)}
        >
            <InputText
                id="vat_name"
                type="text"
                label={t("document.form.vat_name", {defaultValue: "Nome"})}
                errors={errors.name}
                input={{
                    ...register("name", {
                        required: true,
                        validate: (value) => (value ?? "").trim().length > 0,
                    }),
                }}
                isRequired
            />

            <InputText
                id="vat_code"
                type="text"
                label={t("document.form.vat_code", {defaultValue: "Codice"})}
                errors={errors.code}
                input={{
                    ...register("code", {
                        required: true,
                        validate: (value) => (value ?? "").trim().length > 0,
                    }),
                }}
                isRequired
            />

            <Controller
                control={control}
                name="value"
                rules={{required: true, min: 0}}
                render={({field: {value, onChange}}) => (
                    <InputFormattedNumber
                        id="vat_value"
                        label={t("document.form.vat_value", {defaultValue: "Aliquota"})}
                        value={value}
                        onChange={onChange}
                        suffix=" %"
                        decimalScale={2}
                        allowNegative={false}
                        errors={errors.value}
                        isRequired
                    />
                )}
            />

            <InputText
                id="vat_description"
                type="textarea-2"
                label={t("document.form.vat_description", {defaultValue: "Descrizione"})}
                errors={errors.description}
                input={{...register("description")}}
            />

            {exception && <Warning message={exception} />}

            <div className="pt-2">
                <InputSubmit
                    isLoading={isLoading}
                    isFullWith
                    label={t("app.form.save", {defaultValue: "Salva"})}
                />
            </div>
        </form>
    );
};

VatModalForm.propTypes = {
    onSubmitData: PropTypes.func,
    isLoading: PropTypes.bool,
    exception: PropTypes.string,
};

VatModalForm.defaultProps = {
    onSubmitData: null,
    isLoading: false,
    exception: null,
};

export default VatModalForm;
